import {Tooltip} from 'bootstrap';
export const bsTooltip = {
	mounted(el, bindings) {
		let options = bindings.value;
		new Tooltip(el, options);
	}
};